// components/TalonariosTable.js
import React, { useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { Button, Typography, IconButton, Tooltip } from '@mui/material';
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from 'moment';

const TalonariosTable = ({ 
  data, 
  onNuevoClick, 
  onEditarClick, 
  onEliminarClick,
  onActivarClick,
  loading 
}) => {
  const formatearFecha = (fechaString) => {
    if (!fechaString) return "-";
    return moment(fechaString).format("DD-MM-YYYY HH:mm");
  };
  console.log("data",data);
  

  const columns = useMemo(
    () => [
    //   {
    //     accessorKey: "id",
    //     header: "ID",
    //     size: 70,
    //   },
    //   {
    //     accessorKey: "id_tipo_talonario",
    //     header: "Tipo",
    //     size: 80,
    //     Cell: ({ cell }) => {
    //       const tipoMap = {
    //         1: 'Remito',
    //         2: 'Factura',
    //         3: 'Nota Crédito'
    //       };
    //       return tipoMap[cell.getValue()] || cell.getValue();
    //     }
    //   },
      {
        accessorKey: "username",
        header: "Usuario",
        size: 120,
      },
      {
        accessorKey: "pto_venta",
        header: "Punto Venta",
        size: 100
      },
      {
        accessorKey: "numero_completo_desde",
        header: "Número Desde",
        size: 150,
        Cell: ({ cell }) => cell.getValue() || '-'
      },
      {
        accessorKey: "numero_completo_hasta",
        header: "Número Hasta",
        size: 150,
        Cell: ({ cell }) => cell.getValue() || '-'
      },
      {
        accessorKey: "fecha_asignado",
        header: "Fecha Asignación",
        size: 180,
        Cell: ({ cell }) => formatearFecha(cell.getValue()),
      },
    //   {
    //     accessorKey: "activo",
    //     header: "Estado",
    //     size: 100,
    //     Cell: ({ cell }) => (
    //       <span style={{ 
    //         color: cell.getValue() === 1 ? '#2e7d32' : '#c62828',
    //         fontWeight: 'bold',
    //         backgroundColor: cell.getValue() === 1 ? '#e8f5e9' : '#ffebee',
    //         padding: '4px 8px',
    //         borderRadius: '4px',
    //         display: 'inline-block'
    //       }}>
    //         {cell.getValue() === 1 ? 'ACTIVO' : 'INACTIVO'}
    //       </span>
    //     ),
    //   },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
    sorting: [{ id: "fecha_asignado", desc: true }],
    grouping: ["username"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };

  const getRowColor = (activo) => {
    return activo === 1 ? "#e8f5e9" : "#ffebee";
  };

  return (
    <MaterialReactTable
      localization={MRT_Localization_ES}
      columns={columns}
      data={data ?? []}
      layoutMode="grid"
      initialState={initialState}
      enableColumnActions={false}
      enableGlobalFilterModes={false}
      enableHiding={false}
      enableRowActions={true}
      positionToolbarAlertBanner="none"
      enableGrouping
      enableColumnFilters={false}
      enableFullScreenToggle={false}
      positionActionsColumn="last"
      enableExpandAll={false}
      enableToolbarInternalActions={true}
      muiTableHeadCellProps={tableHeadCellProps}
      enableDensityToggle={false}
      displayColumnDefOptions={displayColumnDefOptions}
      enableColumnResizing={true}
      muiTableBodyRowProps={({ row }) => ({
        sx: {
          backgroundColor: getRowColor(row.original.activo),
        },
      })}
      muiTableBodyCellProps={{
        align: "left",
        sx: { color: "black" },
      }}
      renderRowActions={({ row }) => (
        <div>
         
          <Tooltip title={row.original.activo === 1 ? "Desactivar" : "Activar"}>
            <IconButton 
              onClick={() => onActivarClick(row.original)}
              size="small"
              color={row.original.activo === 1 ? "warning" : "success"}
            >
              {row.original.activo === 1 ? <CancelIcon /> : <CheckCircleIcon />}
            </IconButton>
          </Tooltip>
        </div>
      )}
      renderTopToolbarCustomActions={() => (
        <>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddBoxTwoToneIcon />}
            onClick={onNuevoClick}
          >
            Nuevo Talonario
          </Button>
          <Typography variant="poster" fontSize={26} sx={{ ml: 2 }}>
            <AssignmentIndIcon sx={{ fontSize: 20, mr: 1 }} />
            Administración de Talonarios
          </Typography>
        </>
      )}
      state={{ 
        isLoading: loading,
        showProgressBars: loading 
      }}
    />
  );
};

export default TalonariosTable;